import React, { useEffect, useState } from 'react';
import Header from '../general/Header';
import SubHeader from '../general/SubHeader';
import BottomBanner from '../general/BottomBanner';
import MyMedicine from '../assets/my-medicine.gif';
import { useLocation, useNavigate } from 'react-router-dom';
import ResponseMsg from '../general/ResponseMsg';
import Copyright from '../general/Copyright';
import '../css/components/Shop.css';

const Shop = ({ isUser, userData }) => {
    const [response, setResponse] = useState(null);
    const [products, setProducts] = useState([]);
    const [cart, setCart] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortOption, setSortOption] = useState('');
    const [showFilter, setShowFilter] = useState(false);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const query = params.get('search') || '';
        setSearchQuery(query);
    }, [location]);
    

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch(`https://api.kcmstore.in/store/get-product`);
                if (response.ok) {
                    const data = await response.json();
                    const sortedProducts = data.sort((a, b) => b.id - a.id);

                    // if (isUser) {
                    //     const myStateProducts = userData.state
                    //         ? sortedProducts.filter(product => product.subadmin_state === userData.state)
                    //         : sortedProducts;
                    //     setProducts(myStateProducts);
                    // }
                    // else {
                        setProducts(sortedProducts);
                    // }
                } else {
                    console.error('Failed to fetch products');
                }
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };
            if(userData != null){
                        const updateCartFromStorage = async () => {
        const response = await fetch(`https://api.kcmstore.in/store/get-mycart/${userData.id}`);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
        setCart(sortedProducts || []);
        } else {
            setCart([]);
        }

    };

    updateCartFromStorage();
}
        fetchProducts();
    }, []);



    const handleAddCart = async(product) => {
        if (!isUser) {
            setResponse('Login to your account first.');
            setTimeout(() => {
                setResponse('');
            }, 2000);
            return;
        }

        if (!userData.state) {
            setResponse('Update your address details in Profile.');
            setTimeout(() => {
                setResponse('');
            }, 2000)
            return;
        }


        if (product.stock == '0') {
            setResponse('This product is currently out of stock.');
            setTimeout(() => {
                setResponse('');
            }, 2000);
            return;
        }

          if (product.added_pres == 'yes') {
      setResponse('Upload Medical Prescription to Order this Medicine.');
          navigate(`/medicine-details/${product.name}`, { state: { product } })
      setTimeout(() => setResponse(''), 3000);
      return;
    }


        setResponse('Product added to cart.');
        setTimeout(() => {
            setResponse('');
        }, 2000);
             try {
    const response = await fetch(`https://api.kcmstore.in/store/add-to-cart/${userData.id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        prod_name: product.name,
        item_qty: 1,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      console.log('✅ Cart synced with backend:', data);
    } else {
      console.error('❌ Failed to sync cart:', data.message || 'Unknown error');
    }
  } catch (error) {
    console.error('⚠️ Network error while syncing cart:', error);
  }

          navigate(`/medicine-details/${product.name}`, { state: { product } })

        window.dispatchEvent(new Event('cartUpdated'));
    };

    // const filteredProducts = products.filter((product) => {
    //     const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase());
    //     const matchesCategory = selectedCategories.length === 0 || selectedCategories.includes(product.category);
    //     return matchesSearch && matchesCategory;
    // });

    const filteredProducts = products.filter((product) => {
  const query = searchQuery.toLowerCase();

  const matchesSearch =
    product.name?.toLowerCase().includes(query) ||
    product.brand?.toLowerCase().includes(query) ||
    product.category?.toLowerCase().includes(query) ||
    product.composition?.toLowerCase().includes(query);

  const matchesCategory =
    selectedCategories.length === 0 ||
    selectedCategories.includes(product.category);

  return matchesSearch && matchesCategory;
});

    const sortedProducts = filteredProducts.sort((a, b) => {
        if (sortOption === 'low-to-high') {
            return parseFloat(a.sell_price) - parseFloat(b.sell_price);
        } else if (sortOption === 'high-to-low') {
            return parseFloat(b.sell_price) - parseFloat(a.sell_price);
        }
        return 0;
    });

    const handleSortChange = (event) => {
        setSortOption(event.target.value);
    };

    const handleCategoryChange = (category) => {
        setSelectedCategories(prevCategories => {
            if (prevCategories.includes(category)) {
                return prevCategories.filter(cat => cat !== category);
            } else {
                return [...prevCategories, category];
            }
        });
    };



const [visibleCount, setVisibleCount] = useState(30);
useEffect(() => {
  setVisibleCount(30);
}, [searchQuery, selectedCategories, sortOption]);

useEffect(() => {
  const interval = setInterval(() => {
    setVisibleCount((prev) => {
      if (prev >= sortedProducts.length) {
        clearInterval(interval);
        return prev;
      }
      return prev + 30;
    });
  }, 3000);

  return () => clearInterval(interval);
}, [sortedProducts]);


    return (
        <>
            <Header isUser={isUser} setSearchQuery={setSearchQuery} userData={userData} />

            <SubHeader message="Shop" />

            <section className='my-5'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-3 col-md-3 col-12 my-2 d-lg-block d-md-block d-none'>
                            <p className='fs-5 fw-bold'>Category</p>
                            {products.length > 0 ? (
                                [...new Set(products.map(product => product.category))].map((category) => (
                                    <div class="form-check fw-semibold" key={category}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value={category}
                                            checked={selectedCategories.includes(category)}
                                            onChange={() => handleCategoryChange(category)}
                                        />
                                        <label className="form-label" htmlFor="flexCheckDefault">{category}</label>
                                    </div>
                                ))
                            ) : (
                                <p>No Categories available</p>
                            )}
                        </div>

                        <div className='col-lg-9 col-md-9 col-12 my-2'>

                            <div className='d-lg-flex d-md-flex d-block justify-content-between'>
                            <p className='sec-heading my-0'>Featured Products</p>

<div className='d-flex justify-content-between mt-lg-0 mt-md-0 mt-3'>
    <div className='sort-btn'>
                                <select
                                    className='sort-btn'
                                    value={sortOption}
                                    onChange={handleSortChange}
                                    aria-label="Sort products">
                                    <option value="">Sort By: Price</option>
                                    <option value="low-to-high">Low to High</option>
                                    <option value="high-to-low">High to Low</option>
                                </select></div>
                                <span className='align-content-center fs-4 text-darkblue d-lg-none d-md-none d-block' onClick={() => setShowFilter(true)}><i class="fa-solid fa-sliders"></i>
                                &nbsp;&nbsp;<span className='fs-6 fw-semibold text-dark'>Filter</span></span>
                                </div>
                            </div>

                            <div className='row mt-4'>
                                {sortedProducts.length > 0 ? (
                                    sortedProducts.slice(0, visibleCount).map((product) => {
                                        // const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
                                        // const productIndex = cart.findIndex(item => item.medicine_id === product.id);
                const existingCart = cart || [];
const productIndex = existingCart.findIndex(
  item => item.prod_name.toLowerCase() === product.name.toLowerCase()
);                const isInCart = productIndex !== -1;

                                        return (
                                            <div className='col-lg-4 col-md-6 col-6 my-2' key={product.medicine_id}>
                                                <div className='featured-area'>
                                                    <div onClick={() => navigate(`/medicine-details/${product.name}`, { state: { product } })}>
                                                    <div className='featured-btn-area d-block bg-transparent'>
                                                        <p className='text-muted fw-semibold bg-light px-2 py-1 rounded'>
                                                            {product.stock == '0' ? 'Out of Stock' : ''}
                                                        </p>
                                                    </div>

                                                    <img src={`https://api.kcmstore.in/sUploads/${product.image.split(',')[0]}`} className='img-fluid' alt='Product' />
                                                    <p className='featured-category'>{product.unit}</p>
                                                    <p className='featured-name cursor-pointer'>
                                                        {product.name}
                                                    </p>
                                                    <p className='featured-price d-flex justify-content-center'>
                                                        ₹ {product.sell_price}
                                                        {product.discount_amount > 0 && (
                                                            <p className='text-start ps-2 text-muted fw-semibold fs-6 my-0'>
                                                                {product.discount_amount}{product.discount_type === 'percent' ? '%' : '₹'} Off
                                                            </p>
                                                        )}
                                                    </p></div>
                                                    {isInCart ?
                                                        <button
                                                            className='add-to-cart w-100 bg-dark text-white' onClick={() => navigate(`/medicine-details/${product.name}`, { state: { product } })}>Added to Cart</button>
                                                        : <button
                                                            className='add-to-cart w-100'
                                                            onClick={() => handleAddCart(product)}
                                                            disabled={product.stock === '0'}
                                                        >+ Cart</button>}
                                                </div>
                                            </div>
                                        );
                                    })) : (
                                    <div className='text-center'>
                                        <img src={MyMedicine} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                                        <p className='fw-bold'>No Medicine available in your Area.</p>
                                    </div>
                                )}
                            </div>
                            {/* inner row ends */}
                        </div>
                    </div>
                    {/* row ends */}
                </div>
            </section>

            <BottomBanner />

            {showFilter && (
                <div className='show-filter animate__animated animate__fadeInLeft'>
                    <span className='float-end' onClick={() => setShowFilter(false)}><i class="fa-solid fa-xmark"></i></span>
                    <p className='fw-bold'>Category</p>
                    {products.length > 0 ? (
                        [...new Set(products.map(product => product.category))].map((category) => (
                            <>
                                <hr />
                                <div class="form-check fw-semibold" key={category}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={category}
                                        checked={selectedCategories.includes(category)}
                                        onChange={() => handleCategoryChange(category)}
                                    />
                                    <label htmlFor="flexCheckDefault">{category}</label>
                                </div>
                            </>
                        ))
                    ) : (
                        <p>No Categories available</p>
                    )}
                </div>
            )}

            {!isUser && <Copyright />}

            {response && <ResponseMsg message={response} />}
        </>
    );
};

export default Shop;
